import Vue from "vue";

//processing：数据处理；prefix：字段追加；show： 显示信息

Vue.filter("processing_float", v => {
    return parseFloat(v || 0).toFixed(2);
});

Vue.filter("processing_unit", v => {
    if (!v || Object.keys(v).length <= 0) return;
    return v.totalPrice / JSON.parse(v.pricingFormula).totalArea2;
});

Vue.filter("processing_unitPrice", v => {
    console.log("计算单价数据", v);
    let _prices = 0,
        _price = {};
    JSON.parse(v.productItemInfo).forEach((n, i) => {
        let selectId = n["selectId"][0];
        n.children.forEach(c => {
            if (c.id == selectId) {
                if (c.price > 1 && c.price) {
                    _price[i] = c.price - 1 || 0;
                } else if (c.price < 1 && c.price) {
                    _price[i] = -(1 - c.price) || 0;
                } else {
                    _price[i] = 0;
                }
            }
        });
    });
    for (var n in _price) {
        _prices += parseFloat(_price[n]);
    }

    let _pricingFormula = JSON.parse(v.pricingFormula),
        _totalPrice =
        parseFloat(v.totalPrice).toFixed(2) * v.orderNum - v.proportionTotal,
        _total = parseFloat(
            _pricingFormula.bascTotalPrice * v.orderNum * /*_prices||*/ 0 +
            _totalPrice
        ).toFixed(2),
        _unitPrice = parseFloat(
            _pricingFormula.totalArea2 == 0 ?
            0 :
            _total / _pricingFormula.totalArea2 / v.orderNum
        ).toFixed(2);
    // console.log(_pricingFormula.totalArea2 == 0 ? 0 : _total / _pricingFormula.totalArea2 / v.orderNum)
    return _unitPrice + "元";
});

Vue.filter("processing_totalArea2", v => {
    if (!v) return;
    return JSON.parse(v).totalArea2;
});

Vue.filter("prefix_bracket", v => {
    return " ( " + v + " )";
});

Vue.filter("prefix_rmb", v => {
    return "￥" + v;
});

Vue.filter("number_minus", v => {
    return "-" + v;
});

Vue.filter("prefix_yuan", v => {
    return v + "元";
});

Vue.filter("prefix_product", v => {
    return "产品类型：" + v;
});

Vue.filter("prefix_colon", v => {
    return v + "：";
});

Vue.filter("prefix_total", v => {
    return "合计：" + v;
});

Vue.filter("prefix_quantity", v => {
    return v + "套";
});

Vue.filter("prefix_cm", v => {
    console.log(v, "---------------------------有效位数");
    return v.toFixed(2) + "cm";
});

Vue.filter("prefix_orderNo", v => {
    return "订单号：" + v;
});

Vue.filter("prefix_realName", v => {
    return "所属业务员：" + v;
});

Vue.filter("prefix_craftComma", v => {
    if (!v) return v;
    return "，" + v;
});

Vue.filter("show_orderType", v => {
    return v == 1 ? "线下订单" : "线上订单";
});

Vue.filter("show_isPhoto", v => {
    return v == 1 ? "无图报价" : "截图报价";
});

Vue.filter("show_clientStatus", v => {
    //3游客
    return v == 0 ? "未审核" : v == 1 ? "审核通过" : v == 2 ? "审核不通过" : "";
});

Vue.filter("show_clientRozen", v => {
    return v == 1 ? "冻结" : "未冻结";
});

Vue.filter("show_payName", v => {
    return v <= 1 || v > 6 ? "应付金额" : "实付金额";
});

Vue.filter("show_payType", v => {
    return (
        "支付方式：" +
        (v.orderType == 1 && v.payTime != null ?
            "审核通过" :
            v.payType == 1 ?
            "微信支付" :
            "支付宝支付")
    );
});

Vue.filter("show_payTime", v => {
    return "支付时间：" + v;
});

Vue.filter("show_processState", v => {
    return v == 1 ? "停用" : "正常";
});

Vue.filter("show_processType", v => {
    return v == 1 ? "启用" : "停用";
});

Vue.filter("show_processRelevance", v => {
    return v == false ? "否" : "是";
});

Vue.filter("show_processUnit", v => {
    return v == 1 ? "公分" : v == 2 ? "个数" : "一口价";
});

Vue.filter("show_factoryType", v => {
    return v == 0 ? "内部" : "外协";
});

Vue.filter("show_ApplicationStatus", v => {
    //3游客
    return v == 0 ? "未通过" : v == 1 ? "通过" : v == 2 ? "已重新开启" : "其它";
});

Vue.filter("show_factoryVacation", v => {
    return v == false ? "未配置" : "已配置";
});

Vue.filter("show_FactoryOrderList", v => {
    var value = "";
    switch (v + "") {
        case "2":
            value = "未开工";
            break;
        case "3":
            value = "生产中";
            break;
        case "4":
            value = "已发货";
            break;
        case "5":
            value = "已收货";
            break;
        case "8":
            value = "已分配";
            break;
        case "21":
            value = "暂停中";
            break;
    }
    return value;
});

Vue.filter("show_isDownMake", v => {
    return v.isUpdateOfDownMake > 0 && v.isUpdateOfDownMake >= v.isUpdate ?
        "已下载" :
        v.isUpdate > 0 ?
        "已修改" :
        v.isDownMake > 0 ?
        "已下载" :
        "未下载";
});

Vue.filter("show_isDownProduction", v => {
    return v.isUpdateOfDownProduction > 0 &&
        v.isUpdateOfDownProduction >= v.isUpdate ?
        "已下载" :
        v.isUpdate > 0 ?
        "已修改" :
        v.isDownProduction > 0 ?
        "已下载" :
        "未下载";
});

Vue.filter("show_festimatedTime", v => {
    if (!v) return "";
    let [ymd] = v.split(" ");
    return ymd;
});

Vue.filter("show_submittedStatus", v => {
    return v != undefined ? (v == 1 ? "暂停" : "启动") : "暂停";
});

Vue.filter("show_modeOfTransport", v => {
    let value = "";
    switch (v) {
        case 1:
            value = "送货";
            break;
        case 2:
            value = "快递";
            break;
        case 3:
            value = "自提";
            break;
        case 4:
            value = "到付";
            break;
        case 5:
            value = "自定义";
            break;
    }
    return value;
});

Vue.filter("show_leagueStatus", v => {
    return v == 0 ? "待沟通" : "已沟通";
});

Vue.filter("show_userType", v => {
    return v == 1 ? "客服" : v == 2 ? "业务员" : "其它人员";
});

Vue.filter("show_workType", v => {
    return v == 1 ? "排版" : v == 2 ? "录单" : v == 3 ? "报价" : "其它";
});

Vue.filter("show_itsState", v => {
    return v == 8 ? "取消紧急撤单" : "紧急撤单";
});

Vue.filter("show_ftransfer", v => {
    return v == 3 ? "订单转移" : "订单转移主管";
});

Vue.filter("offlineOrders_state", v => {
    return v == 1 ? "待审核" : v == 2 ? "审核通过" : "其它";
});

Vue.filter("show_factoryOrderStatus", v => {
    switch (v + "") {
        case "0":
            return "开工中";
        case "1":
            return "已暂停";
        case "2":
            return "已发货";
        case "3":
            return "未开工";
        case "4":
            return "已超时";
        case "5":
            return "加急";
    }
});

Vue.filter("show_orderStatus", v => {
    switch (v + "") {
        case "0":
            return "审核中";
        case "1":
            return "未支付";
        case "2":
            return "下单成功";
        case "3":
            return "生产中";
        case "4":
            return "已发货";
        case "5":
            return "完成收货";
        case "6":
            return "订单完成";
        case "7":
            return "订单审核不通过";
        case "8":
            return "已分配";
        case "20":
            return "退款中";
        case "21":
            return "退款完成";
    }
});

Vue.filter("show_refundStatus", v => {
    switch (v + "") {
        case "0":
            return "申请中";
        case "1":
            return "已退款";
        case "2":
            return "已拒绝";
        case "3":
            return "已取消退款";
        case "6":
            return "待用户确认";
    }
});

//报价单列表展示字体类型
Vue.filter("offerFontsType", (v, r) => {
    var value = "";
    switch (v + "") {
        case "1":
            value = "标志";
            break;
        case "2":
            value = "中文";
            break;
        case "3":
            value = "英文";
            break;
        case "4":
            value = "字";
            break;
        case "5":
            value = "长条";
            break;
    }
    return value;
});

// 保留两位小数
Vue.filter("toFix", (v, length = 2) => {
    return parseFloat(v || 0).toFixed(length); // 此处2为保留两位小数，保留几位小数，这里写几
});


// WEBPACK FOOTER //
// ./src/filters/filters.js